import type { Question } from './questionnaire';

export interface Customer {
  primary_color: string;
  primary_color_light: string;
  primary_color_dark: string;
  secondary_color: string;
  strong_color: string;
  library_endpoint: string | null;
  logo_url: string;
  welcome_text: string | null;
  questionnaireName: string;
  variant: string;
  disable_buy_button: boolean;
  questionnaireData: Question | null;
  questionnaireAllQuestions: Question[] | null;
  header_images: string[]|null,
}

export class Styling {
  public static PrimaryColor(alphaPercentage: number = -1): string {
    const alphaStr: string = alphaPercentage >= 0 && alphaPercentage < 1 ? Math.floor(255 * alphaPercentage).toString(16) : "";
    if( window.customer ) { return window.customer.primary_color + alphaStr; }
    return "#8B2560" + alphaStr;
  }

  public static SecondaryColor(alphaPercentage: number = -1): string {
    const alphaStr: string = alphaPercentage >= 0 && alphaPercentage < 1 ? Math.floor(255 * alphaPercentage).toString(16) : "";
    if( window.customer ) { return window.customer.secondary_color + alphaStr }
    return "#EA5F36" + alphaStr;
  }

  public static PrimaryColorDark(): string {
    if( window.customer ) { return window.customer.primary_color_dark; }
    return "#711F48";
  }

  public static BorderHover(): string {
    if( window.customer ) { return window.customer.primary_color + "80" }
    return "#8B256080";
  }

  public static BorderSecondary(): string {
    return "#F9EBF2";
  }
}